import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';
import { environment } from 'projects/service/src/environments/environment';

// Cycle Counts → Add Cycle Count → "Warehouses": the warehouses the user may create a cycle count for, checked to
// create many at once. Same columns and labels as the Syncfusion grid it replaces. Rows come from
// api/grid/cycle-count-warehouses: fnGetWarehouseDataForCycleCountCreation for the employee in the login token.

const SHOWN = ['warehouse', 'employeeName', 'serviceDepartment', 'lastCycleCount'];

export const CYCLE_COUNT_ADD_GRID_CONFIG: GridConfig = {
  apiBaseUrl: `${environment.apiUrl}grid/cycle-count-warehouses`,
  // Technician + warehouse: one warehouse can come back for several technicians (LEFT.md F-6).
  keyColumn: 'id',
  selectable: true,
  defaultColumnOrder: SHOWN,
  defaultSort: { column: 'employeeName', direction: 'asc' },
  // employeeId is sent back to Create (BulkCreateCycleCount needs it), never shown before; id is the row key.
  hiddenByDefaultColumns: ['employeeId', 'id'],
  columnLabels: {
    warehouse: 'Warehouse', employeeName: 'Technician Name', serviceDepartment: 'Service Department',
    lastCycleCount: 'Last Cycle Count Date', employeeId: 'Technician Id',
  },
  // RIMS grid look: headers left; text and dates left; codes and IDs centred.
  columnAlign: Object.fromEntries([...SHOWN, 'employeeId'].map(c => [c, {
    header: { horizontal: 'left' as const }, ...(['warehouse', 'employeeId'].includes(c) ? { horizontal: 'center' as const } : {}),
  }])),
  columnWidths: { warehouse: 120, employeeName: 220, serviceDepartment: 180, lastCycleCount: 170, employeeId: 120 },
  columnSizing: {
    warehouse: { min: 100, noStretch: true }, lastCycleCount: { min: 150, noStretch: true },
    employeeId: { min: 100, noStretch: true },
  },
  stretchColumns: true,
  columnDateFormats: { lastCycleCount: 'd MMM, yyyy' },
  excelFilterColumns: ['employeeName', 'serviceDepartment'],
  enableContextMenuFilter: true,
  // Excel export, as before (no role rule on this popup).
  enableExport: true,
  enableFitColumns: true,
  enableResetLayout: true,
  enableSavedViews: true,
  wrapHeaders: true,
  rowHeight: 26,
  loadingIndicator: 'banner',
  emptyStateMessage: 'No warehouse is available for a new cycle count.',
  persistenceKey: 'rims.service.cycle-count-add-warehouses',
  firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  persistenceVersion: 1,
};
